import { Component } from '@angular/core';
import { ViewportScroller } from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from './shared/services/global.service';
import { ApiService } from './shared/services/api.service';
import { APP_IMAGE, Language, THEMEDATA } from './shared/constants/app.constants';
import { UtilService } from './shared/services/utils.service';
import { catchError, concatMap, map, tap } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public dataInitialized = false;

  public title = 'RSVP.org Event Registration';
  public ipAddress: string = "";
  public jobCode: string = "";

  public jobInfo: any = {};
  public events: any[] = [];
  public questions: any[] = [];
  public pageData: any = {};
  heroImg:string = '';
  infoImg:string ='';
  isjobReservationFailed = false;

  constructor(private _title: Title, private scrollService: UtilService, private globalService: GlobalService, 
    private route: ActivatedRoute, private apiService: ApiService, 
    private scroller: ViewportScroller) {
  }

  
  applyTheme(pagedata:any) {
      const appRoot = document.querySelector('app-root');
      appRoot!.className = '';
      const themelist = THEMEDATA

      const newTheme = pagedata.pageTheme;
      //todo this is where theme will be set, on the basis of theme recieved.. 
      // we need to get object from themes in constants.

      const themeData = themelist.find(item => item.themeId === newTheme?.trim().toUpperCase());
      this.heroImg = pagedata?.sectionHeader?.heroImageURL || themeData?.heroImage || APP_IMAGE.HERO.DEFAULT;
      this.infoImg = pagedata?.sectionContent?.imageMainURL || themeData?.infoImage || APP_IMAGE.CONTENT.DEFAULT
      if (themeData) {
        appRoot?.classList.add(themeData.cssClass);
        this.scrollService.heroImage(this.heroImg);
        this.scrollService.pushTheme(this.infoImg);
      } else{
        appRoot?.classList.add('theme-default-hero');        
        this.scrollService.heroImage(this.heroImg);
        this.scrollService.pushTheme(this.infoImg);
      }
  }

  ngOnInit() {   
    const url = window.location.href;
    const lastFragment = url.substring(url.lastIndexOf('/') + 1)
    this.jobCode = lastFragment ?? "";

    this.globalService.jobInformation.value.jobCode = this.jobCode;
    //this.initializeJobData(this.jobCode);

    this.globalService.jobInformation.subscribe((data) => {
      this.dataInitialized = data.dataInitialized;
    });
    
   
    this.getJobDetails(Number(this.scrollService.removeLastAlphabet(this.jobCode)));
  }

  getJobDetails(jobCode: number) {
    let pageData:any=undefined;
    this.apiService.getIP().pipe(
      concatMap(resIp => {
        this.globalService.ip = resIp.ip;
        return this.apiService.getPageData(jobCode).pipe(
          tap(res => {
            if(res?.status?.toUpperCase() === 'ERROR'){
              throw new Error('Job data returned status=false');
            }
            pageData = res;
             //Set Application Language
            this.globalService.Language = (!res?.spanish)?Language.English:Language.Spanish;
          }),
          map(res => ({ ip: resIp.ip, pageData: res }))
         )
      }),
      concatMap(({ip, pageData}) => {
        return this.apiService.getJobData(jobCode, ip).pipe(

          tap(res => {
            if(res?.status?.toUpperCase() === 'ERROR'){
              throw new Error('Reservation data returned status=false');
            }
            res.availableEvents = (res.availableEvents ?? []).map(this.globalService.adaptNewToOldEvent);
            this.globalService.multiEvent = res?.isMultiEvent;
          }),
          tap(res => {
            res.questions = (res.questions ?? []).map(this.globalService.adaptNewToOldQA);
          }),
          tap(jobDetail => {
            const jobData = Array.isArray(jobDetail.validateCodeResult)?jobDetail.validateCodeResult:[jobDetail.validateCodeResult]
            jobDetail.validateCodeResult = (jobData?? []).map(this.globalService.adaptNewToOldJobDetail)
          })
         )
      }),
      catchError(err => {
        console.error('Error:', err);
        this.isjobReservationFailed = true;
        return [];
      })

    ).subscribe(result => {
      this.isjobReservationFailed = false;
      this.events = result.availableEvents;
      this.questions = result.questions;
      this.jobInfo = result.validateCodeResult[0].ReturnObject;
      this.pageData = pageData;
      if(this.pageData){
        this.applyTheme(this.pageData);
      }
      this._title.setTitle(this.pageData?.sectionHeader?.title);
      //console.log("newToOld" + JSON.stringify(result.availableEvents, null, 2));
      this.initializeJobData()
    })

  }
  

  initializeJobData() {
    let countedEvents = this.events.filter((event: any) => event.EventId !== -1);
    let eventCount = countedEvents.length;

    this.globalService.jobInformation.next({
      ...this.globalService.jobInformation.value,
      jobInfo: this.jobInfo,
      events: this.events,
      questions: this.questions,
      dataInitialized: true,
      eventCount: eventCount,
      pageData: this.pageData
    });
    //this.getJobDetails(496868)
    // this.apiService.getIP().subscribe(
    //   (data) => {
    //     this.ipAddress = data.ip;
    //     this.apiService.getJobInfo(jobCode, this.ipAddress).subscribe(
    //       (data) => {
    //         //this.jobInfo = data.ReturnObject;
    //         this.apiService.getAvailableEvents(jobCode).subscribe(
    //           (data) => {
    //             //this.events = data.ReturnObject;
    //             this.apiService.getQuestions(jobCode).subscribe(
    //               (data) => {
    //                 //this.questions = data.ReturnObject;
    //                 console.log("Job Info:", this.jobInfo);
    //                 console.log("Events:", this.events);
    //                 console.log("Questions:", this.questions);
    //                 let countedEvents = this.events.filter((event: any) => event.EventId !== -1);
    //                 let eventCount = countedEvents.length;

    //                 this.globalService.jobInformation.next({
    //                   ...this.globalService.jobInformation.value,
    //                   jobInfo: this.jobInfo,
    //                   events: this.events,
    //                   questions: this.questions,
    //                   dataInitialized: true,
    //                   eventCount: eventCount
    //                 });
    //                 // this.screenInitialized = true;
    //               },
    //               (error) => {
    //                 // Handle the error here
    //                 console.error('Error fetching data:', error);
    //               }
    //             );
    //           },
    //           (error) => {
    //             // Handle the error here
    //             console.error('Error fetching data:', error);
    //           }
    //         );
    //       },
    //       (error) => {
    //         // Handle the error here
    //         console.error('Error fetching data:', error);
    //       }
    //     );
    //   },
    //   (error) => {
    //     // Handle the error here
    //     console.error('Error fetching data:', error);
    //   }
    // );
  }

}
